import { render } from "./SliderConversation.vue?vue&type=template&id=123747c8&scoped=true"
import script from "./SliderConversation.vue?vue&type=script&lang=js"
export * from "./SliderConversation.vue?vue&type=script&lang=js"

import "./SliderConversation.vue?vue&type=style&index=0&id=123747c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-123747c8"]])

export default __exports__